export enum MenuButtonsIds {
  ACCESS_OWN_TRANSACTIONS = 'accessOwnTransactions',
  ACCESS_TRANSACTIONS = 'accessTransactions',
  LOCK_MEMBER = 'lockMember',
  DELETE_INVITATION = 'deleteInvitation',
  SEND_AGAIN_INVITATION = 'sendAgainInvitation',
  UNLOCK_MEMBER = 'unlockMember',
  TRANSITION_TO_ROLE = 'transitionToRole',
}
